import { SEVERITY } from "@/lib/format";

export function AgingChip({ severity, stale, days, compact }) {
  const eff = stale ? "stale" : severity;
  const s = SEVERITY[eff] || SEVERITY.none;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md border px-1.5 py-0.5 font-mono text-xs ${s.ring} ${s.bg} ${s.text}`}
      data-testid="aging-chip"
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.hex, boxShadow: `0 0 6px ${s.hex}` }} />
      {stale ? "STALE" : s.label}
      {!compact && days != null && <span className="opacity-80 tnum">{days}d</span>}
    </span>
  );
}
